// Configuration centralisée Calendly
export const CALENDLY_PROFILE_URL = 'https://calendly.com/matthieusita-no-codeo';
export const CALENDLY_EMBED_URL = 'https://calendly.com/matthieusita-no-codeo?hide_landing_page_details=1&hide_gdpr_banner=1';
